import { ITieuDeBaoCaoActionTypes } from "../../action-types/category/ITieuDeBaoCaoActions";
import { ITieuDeBaoCaoReducer } from "../../reducer-model/category/ITieuDeBaoCaoReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: ITieuDeBaoCaoReducer = {
    status: eReducerStatusBase.is_not_initialization,
    tieuDeBaoCaos: [],
}

export const TieuDeBaoCaoReducer = (state = iniState, action: ITieuDeBaoCaoActionTypes): ITieuDeBaoCaoReducer => {
    switch (action.type) {
        case "TIEU_DE_BAO_CAO_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "TIEU_DE_BAO_CAO_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                tieuDeBaoCaos: action.payload,
            };
        case "TIEU_DE_BAO_CAO_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "TIEU_DE_BAO_CAO_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                tieuDeBaoCaoEditing: action.payload,
            };
        case "TIEU_DE_BAO_CAO_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "TIEU_DE_BAO_CAO_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "TIEU_DE_BAO_CAO_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "TIEU_DE_BAO_CAO_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "TIEU_DE_BAO_CAO_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "TIEU_DE_BAO_CAO_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "TIEU_DE_BAO_CAO_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}